import Headroom from 'headroom.js';
import React, { useEffect, useState } from 'react';
import { FaFacebook, FaGithub, FaLinkedin } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import * as reactstrap from 'reactstrap';
import { greetings, socialLinks } from '../portfolio';
import './Navigation.css';

function Header() {
  const [collapseClasses, setCollapseClasses] = useState('');
  const onExiting = () => setCollapseClasses('collapsing-out');

  const onExited = () => setCollapseClasses('');

  useEffect(() => {
    const headroom = new Headroom(document.getElementById('navbar-main'));
    // initialise
    headroom.init();
  });
  return (
    <>
      <header className="header-global">
        <reactstrap.Navbar
          className="navbar-main navbar-transparent navbar-light headroom"
          expand="lg"
          id="navbar-main"
        >
          <reactstrap.Container>
            <reactstrap.NavbarBrand className="mr-lg-5" to="/">
              <h2 className="text-white" id="nav-title">
                {greetings.name}
              </h2>
            </reactstrap.NavbarBrand>
            <button className="navbar-toggler" id="navbar_global" type="button">
              <span className="navbar-toggler-icon" />
            </button>
            <reactstrap.UncontrolledCollapse
              toggler="#navbar_global"
              navbar
              className={collapseClasses}
              onExiting={onExiting}
              onExited={onExited}
            >
              <div className="navbar-collapse-header">
                <reactstrap.Row>
                  <reactstrap.Col className="collapse-brand" xs="6">
                    <Link to="/">
                      <h3 className="text-black" id="nav-title">
                        {greetings.name}
                      </h3>
                    </Link>
                  </reactstrap.Col>
                  <reactstrap.Col className="collapse-close" xs="6">
                    <button className="navbar-toggler" id="navbar_global" type="button">
                      <span />
                      <span />
                    </button>
                  </reactstrap.Col>
                </reactstrap.Row>
              </div>
              <reactstrap.Nav className="align-items-lg-center ml-lg-auto" navbar>
                <reactstrap.NavItem>
                  <reactstrap.NavLink
                    style={{ fontSize: '35px' }}
                    className="nav-link-icon p-0"
                    href={socialLinks.facebook}
                    target="_blank"
                  >
                    <FaFacebook />
                    <span className="nav-link-inner--text d-lg-none ml-2">Facebook</span>
                  </reactstrap.NavLink>
                </reactstrap.NavItem>
                <reactstrap.NavItem>
                  <reactstrap.NavLink
                    style={{ fontSize: '35px' }}
                    className="nav-link-icon p-0"
                    href={socialLinks.github}
                    target="_blank"
                  >
                    <FaGithub />
                    <span className="nav-link-inner--text d-lg-none ml-2">Github</span>
                  </reactstrap.NavLink>
                </reactstrap.NavItem>
                <reactstrap.NavItem>
                  <reactstrap.NavLink
                    style={{ fontSize: '35px' }}
                    className="nav-link-icon p-0"
                    href={socialLinks.linkedin}
                    target="_blank"
                  >
                    <FaLinkedin />
                    <span className="nav-link-inner--text d-lg-none ml-2">Linkedin</span>
                  </reactstrap.NavLink>
                </reactstrap.NavItem>
              </reactstrap.Nav>
            </reactstrap.UncontrolledCollapse>
          </reactstrap.Container>
        </reactstrap.Navbar>
      </header>
    </>
  );
}

export default Header;
